import * as THREE from 'three';
import {Batch,makeLab,lineTube,labelSprite} from './scene-detail.js';
import {buildRoofPlant} from './scene-roof.js';
export const OUTLINE=[[-22.6,-9.4],[22.8,-9.4],[22.8,9.6],[4.1,9.6],[4.1,2.4],[-22.6,2.4]];
export function facade(parent,m,height,roof=false){
  const b=new Batch(parent);
  for(let i=0;i<OUTLINE.length;i++){
    const a=OUTLINE[i],c=OUTLINE[(i+1)%OUTLINE.length],dx=c[0]-a[0],dz=c[1]-a[1],len=Math.hypot(dx,dz),angle=-Math.atan2(dz,dx),nx=dz/len,nz=-dx/len;
    const x=(a[0]+c[0])/2,z=(a[1]+c[1])/2;
    b.box(m.edge,x+nx*.16,.16,z+nz*.16,len+.22,.32,.28,angle);b.box(m.silver,x+nx*.2,.38,z+nz*.2,len+.12,.07,.3,angle);
    if(roof){b.box(m.edge,x,.98,z,len+.18,.1,.35,angle);continue;}
    b.box(m.white,x,height-.29,z,len+.2,.56,.38,angle);b.box(m.silver,x+nx*.26,height-.6,z+nz*.26,len+.12,.055,.18,angle);
    const count=Math.max(1,Math.round(len/1.7)),bay=len/count;
    for(let k=0;k<count;k++){
      const t=(k+.5)/count,px=a[0]+dx*t,pz=a[1]+dz*t;
      b.box(m.facade,px+nx*.19,height*.5,pz+nz*.19,bay-.15,height-.95,.065,angle);
      // Warm recessed interior strips give individual windows depth without treating glazing as a painted texture.
      if(k%4===1)b.box(m.light,px+nx*.14,height*.39,pz+nz*.14,bay-.25,.06,.055,angle);
      b.box(m.silver,px+nx*.24,height*.5,pz+nz*.24,.045,height-.9,.075,angle);
      b.box(m.silver,px+nx*.24,height*.51,pz+nz*.24,bay-.08,.045,.075,angle);
      const fx=a[0]+dx*k/count,fz=a[1]+dz*k/count;
      b.box(k%4===0?m.edge:m.white,fx+nx*.28,height*.5,fz+nz*.28,k%4===0?.28:.12,height,.52,angle);
    }
  }
  b.finish(roof?'Roof edge capping':'Curtain wall / anodized frames / vertical fins');
}
export function landscape(parent,m){
  const b=new Batch(parent);
  b.box(m.ground,0,-1.2,0,82,.5,54);b.box(m.road,0,-.88,0,72,.15,43);b.box(m.paving,0,-.68,0,54,.3,30);b.box(m.dark,0,-.86,0,54.3,.12,30.3);
  for(let x=-26;x<=26;x+=1.3)for(const z of[-13.8,13.8]){b.box(m.silver,x,-.51,z,.018,.008,1.4);}
  for(let z=-12;z<12;z+=1.3)for(const x of[-25.5,25.5])b.box(m.silver,x,-.51,z,1.4,.008,.018);
  for(let x=-31;x<=32;x+=4){b.box(m.paving,x,-.79,18,.85,.012,.11);b.box(m.paving,x,-.79,-18,.85,.012,.11);}
  for(let z=-16;z<=16;z+=3){b.box(m.paving,-31,-.79,z,.11,.012,.8);b.box(m.paving,31,-.79,z,.11,.012,.8);}
  // L-shaped court, front entry stair and low planted beds follow the existing footprint.
  b.box(m.paving,-8.5,-.33,7.2,24,.18,8.4);
  for(let k=0;k<4;k++)b.box(m.white,12,-.39+k*.1,11.9-k*.3,8,.2,1.4);
  for(const[x,z,w,d]of[[-14,11.2,16,1.2],[-26,-4,1.3,18],[26,-2,1.3,21],[0,-12.1,28,1.15]]){b.box(m.edge,x,-.42,z,w+.13,.26,d+.13);b.box(m.grass,x,-.26,z,w,.12,d);}
  const trees=[];for(let i=0;i<8;i++)trees.push([-26.2,-10+i*3.3],[26.2,-11+i*3.3]);for(let i=0;i<8;i++)trees.push([-24+i*6.8,-14.1]);for(let i=0;i<5;i++)trees.push([-22+i*5.4,11.3]);
  trees.forEach(([x,z],i)=>{
    const h=2.1+(i%3)*.25;b.cyl(m.bark,x,h/2-.55,z,.11,h);b.box(m.dark,x,-.49,z,1.1,.04,1.1);
    b.ball(i%2?m.leaf:m.leaf2,x,h-.3,z,1.02,1.2);b.ball(m.leaf,x+.55,h-.05,z-.15,.73,1.05);b.ball(m.leaf2,x-.4,h+.17,z+.2,.71,1.2);
  });
  for(let x=-23;x<=23;x+=9)for(const z of[-15.2,15.2]){b.cyl(m.silver,x,1.1,z,.045,3.1);b.box(m.dark,x,2.7,z,.24,.1,.24);b.box(m.light,x,2.64,z,.2,.04,.2);}
  for(let i=0;i<5;i++){const x=-19+i*4.7;b.box(m.warm,x,.05,6.2,1.5,.13,.4);for(const dx of[-.6,.6])b.box(m.silver,x+dx,-.16,6.2,.065,.45,.35);}
  b.finish('Site / trees / pavers / street furniture');
  const grid=new THREE.GridHelper(170,85,0x1b687a,0x143c50);grid.position.y=-1.49;grid.material.transparent=true;grid.material.opacity=.33;parent.add(grid);
  const ring=new THREE.Mesh(new THREE.RingGeometry(31,31.04,128),new THREE.MeshBasicMaterial({color:'#22738b',transparent:true,opacity:.5,side:THREE.DoubleSide}));ring.rotation.x=-Math.PI/2;ring.position.y=-.8;parent.add(ring);
}
export function populateLevel(level,m,floor,api){
  const arch=new THREE.Group();arch.name='ARCHITECTURE_DETAIL';level.add(arch);facade(arch,m,floor.height,floor.id==='RF');
  const equipment=new THREE.Group();equipment.name='EQUIPMENT_DETAIL';level.add(equipment);
  const mep=new THREE.Group();mep.name='MEP_DETAIL';level.add(mep);
  const labels=new THREE.Group();labels.name='LABELS';level.add(labels);
  if(floor.id==='RF'){api.roofDetail=buildRoofPlant(equipment,m,api);for(const group of Object.values(api.roofDetail.systems))mep.add(group);}
  else if(floor.id!=='M'){
    const spots=floor.id==='F1'?[[-12,-6.8],[-4,-6.8],[7,-6.8],[15,-6.8]]:floor.id==='F2'?[[-7.8,.1],[.9,.1],[11.8,-6.8]]:[[-9.3,-6.8],[-2.3,-6.8],[4.8,-6.8],[11.7,-6.8],[11.8,-.65]];
    for(const[x,z]of spots){const lab=new THREE.Group();lab.name=`LAB_${floor.id}_${x}_${z}`;lab.position.set(x,.08,z);equipment.add(lab);makeLab(lab,m,{width:5.7,depth:4.2});}
    const b=new Batch(mep),h=Math.min(floor.height-.55,3.3);
    // Suspended supply / extract trunks and service pipes. All are explicitly conceptual.
    for(const[z,mat,w]of[[-3.6,m.teal,.44],[-2.8,m.amber,.34]]){
      b.box(mat,0,h,z,40,.32,w);
      for(let x=-18;x<20;x+=3.3){b.box(m.silver,x,h,z,.06,.38,w+.08);b.box(m.silver,x,h+.25,z,.025,.45,.025);}
      for(let x=-15;x<20;x+=7){b.box(mat,x,h,-5.4,.3,.25,3.3);b.box(m.silver,x,h-.12,-6.9,.7,.07,.55);}
      api.flowPaths.push({curve:lineTube(mep,[[-20,h+.1,z],[0,h+.1,z],[20,h+.1,z]],mat,.015),parent:mep,color:mat===m.teal?0x9fffff:0xffd386});
    }
    for(let p=0;p<3;p++)lineTube(mep,[[-20,h-.3,-2.2+p*.18],[0,h-.3,-2.2+p*.18],[20,h-.3,-2.2+p*.18]],p===0?m.blue:p===1?m.violet:m.silver,.047);
    b.finish('Suspended MEP services — conceptual');
  }
  if(floor.id==='M'){
    // Railings keep the CAD's large laboratory void open; no benches are placed in the void.
    const b=new Batch(arch);for(let x=-18;x<=18;x+=1.3){b.box(m.silver,x,.56,-3.1,.035,1.1,.035);}b.box(m.silver,0,1.1,-3.1,37,.045,.045);b.box(m.glass,0,.57,-3.1,37,1.0,.025);b.finish('Mezzanine void safety railing');
  }
  const tag=labelSprite(floor.name,`${floor.id} · ${floor.elevation.toFixed(1)} m`,undefined,4.2);tag.position.set(-26,1.8,0);labels.add(tag);
  return{arch,equipment,mep,labels};
}
